// extracted by mini-css-extract-plugin
module.exports = {"Scroll":"Scroll_Scroll__3LDDz","ScrollX":"Scroll_ScrollX__3eHlj","ScrollY":"Scroll_ScrollY__2y0WF"};